export default __webpack_public_path__ + "static/media/pencil.a23059a1.svg";